"use strict";

require("core-js/modules/es.object.assign.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

var _react = _interopRequireDefault(require("react"));

var _react2 = require("@chakra-ui/react");

var _reactSelect = _interopRequireDefault(require("react-select"));

var _excluded = ["name", "type", "form", "placeholder", "isLoading", "value", "options", "bgInput", "colorScheme", "size", "disabled", "isMulti"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var InputType = _ref => {
  var {
    name,
    type,
    form,
    placeholder,
    isLoading,
    value,
    options,
    bgInput,
    colorScheme,
    size,
    disabled,
    isMulti
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  switch (type) {
    case "input":
      return /*#__PURE__*/_react.default.createElement(_react2.Input, _extends({
        isDisabled: disabled
      }, rest, {
        value: value,
        bg: bgInput,
        placeholder: placeholder,
        name: name,
        id: name,
        size: size
      }));

    case "date":
      return /*#__PURE__*/_react.default.createElement(_react2.Input, _extends({
        isDisabled: disabled
      }, rest, {
        value: value,
        bg: bgInput,
        placeholder: placeholder,
        name: name,
        id: name,
        size: size,
        type: "date"
      }));

    case "react-select":
      return /*#__PURE__*/_react.default.createElement(_reactSelect.default, {
        isClearable: true,
        isDisabled: disabled,
        placeholder: placeholder,
        options: options,
        name: name,
        isMulti: isMulti,
        value: options ? options.find(option => option.value === value) : "",
        onChange: option => form.setFieldValue(name, option === null || option === void 0 ? void 0 : option.value),
        onBlur: () => form.setFieldTouched(name, true)
      });

    case "checkbox":
      return /*#__PURE__*/_react.default.createElement(_react2.Checkbox, {
        isDisabled: disabled,
        size: size,
        id: name,
        isChecked: value,
        onChange: e => form.setFieldValue(name, e.target.checked),
        onBlur: () => form.setFieldTouched(name, true)
      }, placeholder);

    case "submit":
      return /*#__PURE__*/_react.default.createElement(_react2.Button, {
        isLoading: isLoading,
        isDisabled: !form.isValid || disabled,
        bg: bgInput,
        colorScheme: colorScheme,
        size: size,
        type: "submit"
      }, placeholder);

    case "cancelar":
      return /*#__PURE__*/_react.default.createElement(_react2.Button, {
        isDisabled: disabled,
        bg: bgInput,
        colorScheme: colorScheme,
        size: size,
        onClick: e => {
          e.preventDefault();
        }
      }, placeholder);

    case "submitBuscador":
      return /*#__PURE__*/_react.default.createElement(_react2.Button, {
        isLoading: isLoading,
        isDisabled: form.isValid && Object.keys(form.values).length === 0 || !form.isValid,
        bg: bgInput,
        colorScheme: colorScheme,
        size: size,
        type: "submit"
      }, placeholder);

    default:
      return null;
  }
};

var _default = InputType;
exports.default = _default;